import { FC, useEffect, ReactElement, useCallback } from 'react'
import { FormApi } from 'final-form'

import {
  ISafetyCaseHazardValues,
  ISafetyCaseHazardUpsertValues,
  Location,
  mapMode as MAP_MODES,
  useGoogleMaps,
} from '../../../components'

import SafetyCaseHazardForm from './safety-case-hazard-form'
import { IGeoJson } from '../../../interfaces'

type SafetyCaseHazardInfoProps = {
  hasWriteAccess?: boolean
  setHeaderControls: (headerControls?: ReactElement) => void
  setHazardGeoJson: (geoJson: IGeoJson | undefined) => void
  handleSaveHazard: (hazardValues: ISafetyCaseHazardValues) => void
  saveHeaderControls: ReactElement
  setSaveHazardForm?: (saveSafetyCaseForm: FormApi<ISafetyCaseHazardValues>) => void
  saveHazardInitialValues?: ISafetyCaseHazardUpsertValues
  setSaveHazardValues?: (safetyCaseHazardUpsertValues: ISafetyCaseHazardUpsertValues) => void
  isSaveFormDisabled?: boolean
}

const SafetyCaseHazardInfo: FC<SafetyCaseHazardInfoProps> = props => {
  const {
    hasWriteAccess,
    setHeaderControls,
    setHazardGeoJson,
    handleSaveHazard,
    saveHeaderControls,
    setSaveHazardForm,
    saveHazardInitialValues,
    setSaveHazardValues,
    isSaveFormDisabled,
  } = props

  const { mapMode, setMapMode } = useGoogleMaps()

  useEffect(() => {
    setHeaderControls(saveHeaderControls)
    return () => setHeaderControls(undefined)
  }, [setHeaderControls, saveHeaderControls])

  const onMapModeChange = useCallback(
    async (newMapMode: string) => {
      let mapMode = newMapMode

      if (newMapMode === MAP_MODES.CLEAR) {
        setHazardGeoJson(undefined)
        mapMode = MAP_MODES.MARKER
      }

      setMapMode(mapMode)
    },
    [setMapMode, setHazardGeoJson],
  )

  useEffect(() => () => setMapMode(MAP_MODES.CLEAR), [setMapMode])

  return (
    <>
      <SafetyCaseHazardForm
        onSubmit={handleSaveHazard}
        disabled={isSaveFormDisabled || !hasWriteAccess}
        isViewMode={!hasWriteAccess}
        initialValues={saveHazardInitialValues}
        formName="safety-case-hazard-form"
        setForm={setSaveHazardForm}
        onChange={setSaveHazardValues}
        baseStatus={'Doing'}
      />

      <div className="mb-4">
        <Location
          hasSavedLocations={false}
          hideSavedLocations={true}
          mapMode={mapMode}
          setMapMode={onMapModeChange}
          disabled={isSaveFormDisabled || !hasWriteAccess}
          entityLabel="hazard"
        />
      </div>
    </>
  )
}

export default SafetyCaseHazardInfo
